/**
 * Given an array of strings, returns a translated string of those items with commas and "and"
 * between the last two items.
 *
 * @example
 * const foo: string[] = listItems(["foo"]);  // "foo"
 * const bar: string[] = listItems(["foo", "bar"]);  // "foo, bar"
 */
export function listItems(items: string[]) {
  const numItems = items.length;
  let itemsList = "";
  if (numItems < 1) {
    return itemsList;
  } else if (numItems === 1) {
    itemsList = items[0];
  } else {
    itemsList = items.join(", ");
  }
  return itemsList;
}
